function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrendingDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "12px",
    height: "12px",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(255,255,255)",
      fillOpacity: 1
    },
    d: "M 23.363281 27.636719 L 23.363281 24.113281 L 27.824219 24.113281 L 20.363281 16.613281 L 14.101562 22.875 L 2.210938 11.0625 L 4.761719 8.550781 L 14.0625 17.851562 L 20.324219 11.585938 L 30.300781 21.5625 L 30.300781 17.25 L 33.789062 17.25 L 33.789062 27.636719 Z M 23.363281 27.636719 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendingDown);
export default __webpack_public_path__ + "static/media/trending_down.2571662dfc761ea18bf984ceb3c0c46b.svg";
export { ForwardRef as ReactComponent };